// @ts-ignore
import type * as SchemaTypes from '../../index';

import { gql } from 'graphql-tag';
import { StoneFragmentDoc } from './fragments/stone.fragment.generated';
import { GemsSelectedFiltersFragmentDoc } from './fragments/selectedFilters.fragment.generated';
import { GemsBoundsFragmentDoc } from './fragments/bounds.fragment.generated';
import { ProductPageListingFragmentDoc } from '../../cms/pageProductListing.fragment.generated';
import { ProductPageFacetedContentFragmentDoc } from '../../product/faceted-content/productPageFacetedContent.fragment.generated';
import * as Urql from '@urql/vue';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export const GemsFindStonesDocument = gql`
    query GemsFindStones($filters: GemsApi_StoneFilters, $market: String!, $categories: [GemsApi_StoneCategory!]!, $notClarity: [GemsApi_StoneClarity!]!, $notColour: [GemsApi_StoneColour!]!, $notSymmetry: [GemsApi_StoneSymmetry!]!, $locale: Locale!, $currency: CurrencyInput!, $region: RegionCode!, $getBound: Boolean!, $getStones: Boolean!, $isConsultant: Boolean, $contentPath: String!, $facetedNav: ProductPageFacetedContentInputDiamondSearch!) {
  GemsApi_findStones(filters: $filters) @include(if: $getStones) {
    collection {
      ...stone
    }
    pagination {
      limit
      pages
      total
    }
    filters {
      ...GemsSelectedFilters
    }
  }
  GemsApi_getBounds(
    market: $market
    categories: $categories
    notClarity: $notClarity
    notColour: $notColour
    notSymmetry: $notSymmetry
    isConsultant: $isConsultant
  ) @include(if: $getBound) {
    ...gemsBounds
  }
  pageProductListing(path: $contentPath, locale: $locale) {
    ...productPageListing
  }
  pageProductListingFacetedContent(
    input: {diamondSearch: $facetedNav}
    locale: $locale
  ) {
    ...productPageFacetedContent
  }
}
    ${StoneFragmentDoc}
${GemsSelectedFiltersFragmentDoc}
${GemsBoundsFragmentDoc}
${ProductPageListingFragmentDoc}
${ProductPageFacetedContentFragmentDoc}`;

export function useGemsFindStonesQuery(options?: Omit<Urql.UseQueryArgs<never, SchemaTypes.GemsFindStonesQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<SchemaTypes.GemsFindStonesQuery, SchemaTypes.GemsFindStonesQueryVariables | undefined>({ query: GemsFindStonesDocument, variables: undefined, ...options });
};